import { widget } from "@foretagsplatsen/widgetjs";
import companyChartLegendWidget from "../shared/companyChartLegend/companyChartLegendWidget.js";

/**
 * `companyOverviewLegendWidget` displays the legend for
 * companyOverviewWidget. It displays the changes in assets,
 * liabilities and owner's part during the selected month.
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {*}
 */
function companyOverviewLegendWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.openingBalanceLegend = companyChartLegendWidget({
		disabled: true,
	});

	my.closingBalanceLegend = companyChartLegendWidget();

	that.setValues = function (companyTransitionBalance) {
		my.openingBalanceLegend.setCompanyBalance(
			companyTransitionBalance.openingBalance,
		);

		my.closingBalanceLegend.setCompanyBalance(
			companyTransitionBalance.closingBalance,
		);

		that.update();
	};

	that.renderContentOn = function (html) {
		html.div(
			{ id: "company-chart-legend", class: "clearfix" },
			html.div(
				{ class: "col-lg-6 col-md-6 col-sm-6 col-xs-6 nopadding" },
				my.openingBalanceLegend,
			),
			html.div(
				{ class: "col-lg-6 col-md-6 col-sm-6 col-xs-6 nopadding" },
				my.closingBalanceLegend,
			),
		);
	};

	return that;
}

export default companyOverviewLegendWidget;
